import {
    Autocomplete,
    Card,
    InputAdornment,
    Stack,
    Switch,
    TextField,
    Typography,
} from '@mui/material';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useCreateListDataMutation } from '../../../api/apiSlice';
import FormikButton from '../../../components/formik/FormikButton';
import FormikInput from '../../../components/formik/FormikInput';
import ExternalScreen from '../../../components/fragments/ExternalScreen';
import Form from '../../../components/utilities/Form';
import { rtGetListData } from '../../../store/slices/listSlice';
import errorSnackbar from '../../../utils/errorSnackbar';

//                     tag: '',
//                     start_at: '',
//                     speakers: [],

export default function ScreenCreateCrusade() {
    const [file, setFile] = React.useState(null);
    const [personName, setPersonName] = React.useState([]);
    const [scheduled, setScheduled] = React.useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const state = useSelector((st) => st);

    const { user } = state.auth;
    const { spouses } = state.list2;

    const [createcrusade, { isLoading }] = useCreateListDataMutation();

    const handleChange = (_, value) => {
        setPersonName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value
        );
    };

    const validator = Yup.object().shape({
        title: Yup.string().min(5).required('Title is required'),
        description: Yup.string().min(10).required('Description is required'),
        image: Yup.string().required('Image is required'),
        tag: Yup.string().required('Tag is required'),
        start_at: Yup.string().when('title', {
            is: () => scheduled == true,
            then: Yup.string().required('Start time is required'),
        }),
    });

    return (
        <ExternalScreen title="Create Crusade">
            <Form
                onSubmit={async (values) => {
                    if (!file) return;

                    const formData = new FormData();
                    formData.append('title', values.title);
                    formData.append('description', values.description);
                    formData.append('image', file);
                    formData.append('tag', values.tag);
                    formData.append('speakers', personName);
                    scheduled &&
                        formData.append(
                            'start_at',
                            moment(values.start_at).format('YYYY/MM/DD HH:mm')
                        );
                    !scheduled &&
                        formData.append(
                            'meeting_id',
                            Date.now() + user?.username
                        );
                    scheduled
                        ? formData.append('type', 'scheduled')
                        : formData.append('type', 'now');

                    const { error, data } = await createcrusade({
                        list: `/op/crusades`,
                        body: formData,
                    });

                    errorSnackbar(error, enqueueSnackbar);

                    if (data) {
                        enqueueSnackbar('Successfully created crusade');
                        navigate(-1);
                    }
                }}
                validationSchema={validator}
                initialValues={{
                    title: '',
                    description: '',
                    image: '',
                    tag: '',
                    start_at: '',
                    speakers: [],
                }}
            >
                <FormikInput name="title" label="Title" />
                <FormikInput
                    name="description"
                    label="Description"
                    multiline
                    rows={4}
                />
                <FormikInput
                    type="file"
                    name="image"
                    label="Cover Image"
                    onSelectFiles={([f]) => setFile(f)}
                    inputProps={{ accept: 'image/*' }}
                />
                <FormikInput
                    name="tag"
                    label="Tag"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">#</InputAdornment>
                        ),
                    }}
                />
                <Card
                    sx={{ my: 1, p: 1.5 }}
                    className="w-100"
                    variant="outlined"
                >
                    <Stack sx={{ my: 0 }} direction="row">
                        <Switch
                            sx={{ mr: 1 }}
                            checked={scheduled}
                            onChange={(e) => setScheduled(e.target.checked)}
                        />
                        <Typography>Sheduled</Typography>
                    </Stack>
                </Card>
                <FormikInput
                    disabled={!scheduled}
                    type="datetime-local"
                    name="start_at"
                    label="Start Date"
                />
                <Autocomplete
                    multiple
                    fullWidth
                    disablePortal
                    sx={{ my: 1 }}
                    options={spouses.map((spouse) => spouse.username)}
                    value={personName}
                    onChange={handleChange}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            onChange={(e) => {
                                dispatch(
                                    rtGetListData(
                                        `members?username=${e.target.value}`,
                                        'spouses'
                                    )
                                );
                            }}
                            placeholder="Search Usernames"
                            label="speakers"
                        />
                    )}
                />
                <div className="d-flex justify-content-end w-100">
                    <FormikButton loading={isLoading} variant="contained">
                        Create
                    </FormikButton>
                </div>
            </Form>
        </ExternalScreen>
    );
}
